import { Form, Row, Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const RequirementsSelector = ({ formData, setFormData, errors }) => {
  const daysOptions = [
    { label: "2 days", value: 2 },
    { label: "3 days", value: 3 },
    { label: "5 days", value: 5 },
  ];

  const timingOptions = [
    { label: "7.45am - 1.30pm", value: "7.45am", end: "1.30pm" },
    { label: "7.45am - 3.00pm", value: "7.45am", end: "3.00pm" },
    { label: "7.45am - 5.00pm", value: "7.45am", end: "5.00pm" },
    { label: "5.00pm - 5.30pm", value: "5.00pm", end: "5.30pm" },
  ];

  const handleDayChange = (value) => {
    setFormData((prev) => ({ 
      ...prev,
      num_of_days: value,
    }));
  };

  const handleTimeChange = (start, end) => {
    const formattedTime = `${start} - ${end}`;
    setFormData((prev) => ({
      ...prev,
      attending_times: [{ time: formattedTime }],
    }));
  };

  return (
    <div>
      <div className="mb-3">
        <FormattedMessage id="preferred_requirements" />
      </div>

      <Row>
        <Col md={6}>
          <Form.Label>
            <strong>Number of days per week</strong>
          </Form.Label>
          {daysOptions.map((day) => (
            <Form.Check
              key={day.value}
              type="radio"
              name="noOfDays"
              id={`noOfDays_${day.value}`}
              label={day.label}
              value={day.value}
              checked={formData.num_of_days === day.value}
              onChange={() => handleDayChange(day.value)}
              className="mb-2"
            />
          ))}
          {errors?.num_of_days && (
            <Form.Group className="mb-4 position-relative">
              <Form.Control.Feedback className="px-3 d-block" type="invalid">
                <FormattedMessage id="error.num_of_days" />
              </Form.Control.Feedback>
            </Form.Group>
          )}
        </Col>

        <Col md={6}>
          <Form.Label>
            <strong>Timings</strong>
          </Form.Label>
          {timingOptions.map((time, idx) => (
            <Form.Check
              key={idx}
              type="radio"
              name="timing"
              id={`timing_${time.label}`}
              label={time.label}
              checked={
                formData.attending_times?.[0]?.time ===
                `${time.value} - ${time.end}`
              }
              onChange={() => handleTimeChange(time.value, time.end)}
              className="mb-2"
            />
          ))}
          {errors?.attending_times && (
            <Form.Group className="mb-4 position-relative">
              <Form.Control.Feedback className="px-3 d-block" type="invalid">
                <FormattedMessage id="error.attending_times" />
              </Form.Control.Feedback>
            </Form.Group>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RequirementsSelector;
